import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapGetters } from "vuex";
import { CURRENT_USER_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardChangelogItem",
  components: {
    ProfileAvatar
  },
  props: {
    changelog: {
      type: Object,
      default: () => ({})
    },
    agentUsername: {
      type: String,
      default: ""
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_DETAILS])), {}, {
    changelogName() {
      if (this.changelog.username === this.CURRENT_USER_DETAILS.username) {
        return this.$t("application-changelog.you");
      } else {
        return `${this.changelog.firstName} ${this.changelog.lastName}`;
      }
    },
    changelogText() {
      const changelogTypeHandler = {
        access: this.handleAccess,
        create: this.handleCreate,
        copy: this.handleCopy,
        request: this.handleRequest,
        document: this.handleDocument,
        status: this.handleStatus,
        print: this.handlePrint,
        coBroker: this.handleCoBroker,
        "insurance-submission": this.handleReferralSubmit,
        creditBureau: this.handleCreditBureau,
        lenderSubmission: this.handleLenderSubmission,
        submissionAgent: this.handleSubmissionAgent,
        mpp: this.handleMPP
      };
      return changelogTypeHandler[this.changelog.type]();
    }
  }),
  methods: {
    handleAccess() {
      return this.$t("application-changelog.accessedApplication");
    },
    handleCreate() {
      return this.$t("application-changelog.createdApplication");
    },
    handleCopy() {
      return this.$t("application-changelog.copiedApplication", this.changelog.metadata);
    },
    handleReferralSubmit() {
      return this.$t("application-changelog.referralSubmitted", {
        productType: this.$t(`provider-product-names.${this.changelog.metadata.product}`),
        providerName: this.changelog.metadata.provider
      });
    },
    handleRequest() {
      const requestType = this.changelog.metadata.type;
      if (Array.isArray(requestType)) {
        const translatedConsolidatedRequests = _mapInstanceProperty(requestType).call(requestType, type => `<li>
          ${this.$t(`application-changelog.consolidatedRequestTypes.${type}`)}
        </li>`);
        return `
          ${this.$t("application-changelog.consolidatedRequest")}
        <br>
        <ul class="bullet">
          ${translatedConsolidatedRequests.join("")}
        </ul>
      `;
      }
      const translatedRequestType = this.$t(`application-changelog.requestTypes.${requestType}`);
      return this.$t("application-changelog.sendRequest", _objectSpread(_objectSpread({}, this.changelog.metadata), {}, {
        requestType: translatedRequestType
      }));
    },
    handleDocument() {
      const action = this.$t(`application-changelog.documentAction.${this.changelog.metadata.action}`);
      return this.$t("application-changelog.documentEvent", _objectSpread(_objectSpread({}, this.changelog.metadata), {}, {
        action
      }));
    },
    handleStatus() {
      const status = this.$t(`application-changelog.applicationStatuses.${this.changelog.metadata.status}`);
      return this.$t("application-changelog.updatedStatus", _objectSpread(_objectSpread({}, this.changelog.metadata), {}, {
        status
      }));
    },
    handlePrint() {
      return this.$t("application-changelog.printedForm", _objectSpread({}, this.changelog.metadata));
    },
    handleCoBroker() {
      return this.$t("application-changelog.coBrokeredApplication", _objectSpread({}, this.changelog.metadata));
    },
    handleCreditBureau() {
      return this.$t("application-changelog.creditBureauRequest", _objectSpread(_objectSpread({}, this.changelog.metadata), {}, {
        status: (this.changelog.metadata.success ? this.$t("global.words.succeeded") : this.$t("global.words.failed")).toLowerCase()
      }));
    },
    handleLenderSubmission() {
      return this.$t("application-changelog.lenderSubmission", _objectSpread({}, this.changelog.metadata));
    },
    handleSubmissionAgent() {
      return this.$t("application-changelog.submissionAgent", _objectSpread({}, this.changelog.metadata));
    },
    handleMPP() {
      return this.$t("application-changelog.mpp", _objectSpread({}, this.changelog.metadata));
    }
  }
});